import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DocumentLayoutComponent } from '@fi-app/document/layout/layout.component';
import { IMediaBankFileReference } from '@fi-shared/media-bank';

@Component({
    selector: 'fi-document-version-view',
    templateUrl: './version-view.component.html',
    styleUrls: ['./version-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'fiDocumentVersionView',
    standalone: false,
})
export class DocumentVersionViewComponent implements OnInit {
    @Input('version') ngModel;
    @Input() activeVersion;
    @Input() templateLayoutModel;
    @Input() compareWith;
    @Input() compareWithVersion: DocumentVersionViewComponent;

    @ViewChild(DocumentLayoutComponent, { static: false }) documentLayout: DocumentLayoutComponent;

    ngOnInit() {
        if (this.compareWith) {
            const templateItems = buildLayoutItemsArray(this.templateLayoutModel),
                compareWithArray = buildLayoutItemsArray(this.compareWith);
            templateItems.forEach((item, index) => {
                item.compareWith = compareWithArray[index];
            });
        }
    }
}

function buildLayoutItemsArray(templateLayout) {
    const result = [];
    templateLayout.placeholders.forEach((placeholder) => {
        if (placeholder.children) {
            placeholder.children.forEach((child) => {
                child.items.forEach((item) => result.push(item));
            });
        } else {
            placeholder.items.forEach((item) => result.push(item));
        }
    });
    return result;
}
